import { render, staticRenderFns } from "./PccHeader.vue?vue&type=template&id=fdfa3fe4&scoped=true&"
import script from "./PccHeader.vue?vue&type=script&lang=js&"
export * from "./PccHeader.vue?vue&type=script&lang=js&"
import style0 from "./PccHeader.vue?vue&type=style&index=0&id=fdfa3fe4&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfa3fe4",
  null
  
)

export default component.exports